export default __webpack_public_path__ + "static/construction-dumpster-banner-beb71af72412296f860bf6e3c1dfa12b.jpg";